import styled from 'styled-components';

export const Button = styled.div`
  position: absolute;
  background: none;
  border: none;
  font-size: 2rem;
  font-weight: 100;
  color: #3a3a3a;
  right: 25px;
  top: 20px;
  cursor: pointer;
`;
